import './header.scss'

import React from 'react'
import { Contrast } from '@entur/layout'
import { GridContainer, GridItem } from '@entur/grid'
import { Paragraph, StrongText } from '@entur/typography'
import { Link, useMatch } from 'react-router-dom'
import { ActionChip } from '@entur/chip'
import { LogOutIcon } from '@entur/icons'
import { useAuth0 } from '@auth0/auth0-react'
import { TopNavigationItem } from '@entur/menu'
import logoProduction from './Entur-Fordelsreise-logo-white.svg'
import logoTest from './Entur-Fordelsreise-logo-yellow.svg'
import logoDev from './Entur-Fordelsreise-logo-green.svg'
import { trackEvent } from '../../utils/tracking-utils'
import { Environment, getEnvironment } from '../../config'

const getLogo = (env: Environment) => {
  switch (env) {
    case Environment.LOCAL:
      return logoDev
    case Environment.DEV:
      return logoDev
    case Environment.STAGING:
      return logoTest
    case Environment.PRODUCTION:
      return logoProduction
  }
}

const logo = getLogo(getEnvironment())

const Header: React.FC = () => {
  const { logout, user } = useAuth0()
  const mainPage = window.location.origin

  const isRapporter = useMatch('/rapporter') != null

  const logoutWithClearance = () => {
    trackEvent('Click-Logout-Button', { category: 'Session' })
    sessionStorage.clear()
    if (logout) logout({ logoutParams: { returnTo: mainPage } })
  }

  return (
    <Contrast>
      <GridContainer className="header auto-margin">
        <GridItem small={3}>
          <Link to={'/'} state={{ resetSearch: true }}>
            <img src={logo} className="header__logo" height="20px" alt="Entur Fordelsreiser" />
          </Link>
        </GridItem>
        <GridItem small={3}>
          <TopNavigationItem className="header__link" active={!isRapporter} as={Link} to="/">
            Søk
          </TopNavigationItem>
          <TopNavigationItem className="header__link" active={isRapporter} as={Link} to="/rapporter">
            Rapporter
          </TopNavigationItem>
        </GridItem>

        <GridItem small={6}>
          <ActionChip className="header__button" onClick={logoutWithClearance}>
            <LogOutIcon />
            Logg ut
          </ActionChip>
          {user && (
            <Paragraph className="header__user-info">
              <StrongText>{user?.name}</StrongText>
            </Paragraph>
          )}
        </GridItem>
      </GridContainer>
    </Contrast>
  )
}

export default Header
